/**
 * Pencil glyph - "drawing tools live here".
 *
 * Its own module because it is a COMPONENT and its companions in
 * `drawingBarChrome.tsx` are plain constants: a `.tsx` that exports both
 * breaks Vite Fast Refresh (react-refresh/only-export-components).
 *
 * Worn by the DrawingBar's collapsed tab on the chart's left edge and by the
 * toolbar's drawing-tools button, so the two read as the same affordance.
 */
export const PencilIcon = ({ size = 14 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
    <path d="m15 5 4 4" />
  </svg>
)
